import { evaluateConditionalSkill } from 'api/targeting'
import { evaluateTargetingForConditionalSets } from 'modules/targeting'
import { path, pathOr } from 'ramda'
import { Message } from 'types/message'
import { sendUsageMetricEvent } from 'utils/metrics'
import { captureException } from 'utils/sentry'

export const evaluateConditionalMessage = async (message: Message) => {

  const conditionsToEvaluate = pathOr([], ['attributes', 'conditionSetsToEvaluate'], message)
  const playbookId = path(['attributes', 'playbookId'], message)

  const targetingRequestPayload = await evaluateTargetingForConditionalSets(conditionsToEvaluate)

  const conditionalSkillPayload = {
    requestingMessageId: message.id,
    conversationId: message.conversationId,
    targetingRequestPayload
  }

  sendUsageMetricEvent('conditional_evaluated', {
    playbookId,
    conditionalSkillPayload,
  })

  try {
    evaluateConditionalSkill(conditionalSkillPayload)
  } catch (err) {
    captureException(new Error(`Failed to evaluate conditional skill`))
  }
}
